import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { NzColDirective, NzRowDirective } from "ng-zorro-antd/grid";
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent } from "ng-zorro-antd/form";
import { NzOptionComponent, NzSelectComponent } from "ng-zorro-antd/select";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { CommonModule, NgIf } from "@angular/common";
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { TimesheetService } from '../../../../services/timesheet.service';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { LookupService } from '../../../../services/lookup.service';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { UserService } from '../../../../services/user.service';
import { DatePickerComponent } from '../../../../shared/components/date-picker/date-picker.component';
import { MultiselectComponent } from "../../../../shared/components/multiselect/multiselect.component";
import { DropdownSelectComponent } from '../../../../shared/components/dropdown-select/dropdown-select.component';

const fields = [
  { field: 'Timeframe', show: true, default: '30 days', extendedMonths: false, extendedYear: false },
  { field: 'status', show: true },
  { field: 'status', show: true },
  { field: 'consumer', show: true },
  { field: 'consumerPplId', show: true },
  { field: 'provider', show: true },
  { field: 'providerPplId', show: true },
  { field: 'chequeNumber', show: true },
  { field: 'payPeriod', show: true },
  { field: 'paymentDate', show: true },
  { field: 'processStatusLkp', show: true },
  { field: 'serviceCode', show: true },
];

@Component({
  selector: 'ppl-timesheet-filter',
  standalone: true,
  imports: [
    ButtonComponent,
    NzColDirective,
    NzFormControlComponent,
    NzFormDirective,
    NzFormItemComponent,
    NzOptionComponent,
    NzRowDirective,
    NzSelectComponent,
    ReactiveFormsModule,
    NgIf,
    AuthorizeDirective,
    NzAutocompleteModule,
    NzDatePickerModule,
    DatePickerComponent,
    CommonModule,
    MultiselectComponent,
    DropdownSelectComponent,
],
  templateUrl: './timesheet-filter.component.html',
  styleUrls: ['./timesheet-filter.component.css']
})
export class TimesheetFilterComponent implements OnInit {
  @Input() filterFields: any[] = fields;
  @Input() includeBusinessStatus: any[] = [];
  @Input() processCodes: any[] = [];
  @Input() includeProcessingStatus: any[] = [];
  @Input() chequeNumbers: any[] = [];
  @Input() initialValues: Record<string, unknown> = {};
  @Input() assignedToUsers: string[] = [];
  @Output() searchEvent = new EventEmitter<any>();
  statusList: LookupValueItem[] = [];
  processStatusList: LookupValueItem[] = [];
  filteredProcessStatusList: LookupValueItem[] = [];
  timesheetServiceCodes: LookupValueItem[] = [];

  payPeriodMultipleSelection = '';

  timesheetSearchForm!: FormGroup;
  consumers = [
    { id: 'PRC-NY-10000802', name: 'Nikhil Malhotra' },
    { id: 'PRC-NY-10000801', name: 'Henderson Branch' },
    { id: 'PRC-NY-10000797', name: 'Renata Laugherane' },
    { id: 'PRC-NY-10000796', name: 'Torry Hunton' },
    { id: 'PRC-NY-10000804', name: 'Gwenni Malhotra' },
  ];

  providers = [
    { id: 'PRC-NY-10000802', name: 'Nikhil Malhotra' },
    { id: 'PRC-NY-10000801', name: 'Henderson Branch' },
    { id: 'PRC-NY-10000797', name: 'Renata Laugherane' },
    { id: 'PRC-NY-10000796', name: 'Torry Hunton' },
    { id: 'PRC-NY-10000804', name: 'Gwenni Malhotra' },
  ];

  filteredConsumers: any[] = [];
  filteredProviders: any[] = [];
  status = [
    { id: '1', name: 'Approved' },
    { id: '2', name: 'Rejected' },
    { id: '3', name: 'In Review' },
  ];

  loopback = [
    { label:'Last 30 days', val: '30 days' },
    { label:'Last 60 days', val: '60 days' },
    { label:'Last 90 days', val: '90 days' },
    { label:'Last 120 days', val: '120 days' },
    { label:'Last 150 days', val: '150 days' },
    { label:'Last 180 days', val: '180 days' },
  ];
  showErrors = false;
  isExtendedYearSelected = false;
  skipServicePeriodValidation = false;


  pageId: string = '';
  tabId: string = '';
  programName!: string;
  payPeriod: any[] = [];

  constructor(private fb: FormBuilder, private timesheetService: TimesheetService,
    private lookupService: LookupService, private dateTimeFormatter: DateTimeFormatterService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    const formFields = this.filterFields.reduce((acc, f) => {
      if (f.show) {
        acc = { ...acc, [f.field]: [f.default ? f.default : null] };
      }
      return acc;
    }, {});
    this.timesheetSearchForm = this.fb.group(formFields);
    if (Object.keys(this.initialValues).length > 0) {
      this.timesheetSearchForm.patchValue(this.initialValues);
    }

    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    const businessStatusList = this.lookupService.getLookupValue('Business Status')
    this.statusList = this.includeBusinessStatus.length ? businessStatusList.filter((status: any) => {
      return this.includeBusinessStatus.includes(status.lkpValueCode);
    }) : businessStatusList;

    const processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    this.processStatusList = this.includeProcessingStatus.length ? processingStatusList.filter((status: any) => {
      return this.includeProcessingStatus.includes(status.lkpValueCode);
    }) : processingStatusList;
    this.filteredProcessStatusList = this.processStatusList;
    this.timesheetServiceCodes = this.lookupService.getLookupValue('timesheet_filter_serviceCode');

    const payPeriodConfiguration = this.filterFields.find(entry => entry.field === 'payPeriod');
    this.getPayPeriod(payPeriodConfiguration?.hideFuturePeriods ?? false);

    if (payPeriodConfiguration && payPeriodConfiguration.multiple) {
      this.payPeriodMultipleSelection = 'multiple';
    }

    const timeFrameConfig = this.filterFields?.find(
      (entry) => entry?.field === 'Timeframe'
    );
    if (timeFrameConfig?.extendedMonths) {
      this.loopback.push(
        { label: 'Last 210 days', val: '210 days' },
        { label: 'Last 240 days', val: '240 days' },
        { label: 'Last 270 days', val: '270 days' },
        { label: 'Last 300 days', val: '300 days' },
        { label: 'Last 330 days', val: '330 days' },
        { label: 'Last 360 days', val: '360 days' }
      );
    }
    this.skipServicePeriodValidation = !!timeFrameConfig?.skipServicePeriodValidation;

    if (timeFrameConfig && timeFrameConfig.extendedYear) {
      this.loopback.push(
        { label: 'Last 390 days', val: '390 days' },
        { label: 'Last 420 days', val: '420 days' },
        { label: 'Last 450 days', val: '450 days' },
        { label: 'Last 480 days', val: '480 days' },
        { label: 'Last 510 days', val: '510 days' }
      );

      if (timeFrameConfig.extendedYearMax540) {
        this.loopback.push({ label: 'Last 540 days', val: '540 days' });
      }

      this.timesheetSearchForm.get('Timeframe')?.valueChanges.subscribe(value => {
        const days = parseInt(value, 10);
        this.isExtendedYearSelected = !isNaN(days) && days > 360;
      });
    }
  }

  getPayPeriod(hideFuturePeriods: boolean) {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        const payPeriodRecords = data.responsedata;
        if (hideFuturePeriods) {
          const today = new Date();
          const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());

          this.payPeriod = payPeriodRecords.filter((record: any) => {
            const startDate = new Date(record.payrollStartDate);
            const startMidnight = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

            return startMidnight <= todayMidnight;
          });
        } else {
          this.payPeriod = payPeriodRecords;
        }
      });
  }

  onInput(e: Event, fieldName: string): void {
    const value = (e.target as HTMLInputElement).value;

    if (fieldName === 'consumer') {
      this.filteredConsumers = value ? this.consumers.filter(c => c.name.toLowerCase().includes(value.toLowerCase())) : [];
    } else if (fieldName === 'provider') {
      this.filteredProviders = value ? this.providers.filter(c => c.name.toLowerCase().includes(value.toLowerCase())) : [];
    }

  }

  get servicePeriodMissing(): boolean {
    if (!this.isExtendedYearSelected || this.skipServicePeriodValidation) return false;
    const value = this.timesheetSearchForm.get('payPeriod')?.value;
    return !value || (Array.isArray(value) && value.length === 0);
  }

  search() {
    this.showErrors = false;
    if (this.servicePeriodMissing) return;
    this.searchEvent.emit(this.timesheetSearchForm.value);
  }

  onSearchChequeClick() {
    this.showErrors = false;
    if(this.timesheetSearchForm.get('consumerPplId')?.value && this.timesheetSearchForm.get('consumerPplId')?.value.trim() &&
     this.timesheetSearchForm.get('providerPplId')?.value && this.timesheetSearchForm.get('providerPplId')?.value.trim()) {
      this.searchEvent.emit({...this.timesheetSearchForm.value, "chequeLookUp": true});
    } else {
      this.showErrors = true;
    }
  }

  disabledFutureDates = (current: Date): boolean => {
    const serviceDateConfiguration = this.filterFields?.find(entry => entry.field === 'serviceDate');
    if (serviceDateConfiguration?.hideFuturePeriods) {
      const today = new Date();
      return current.getTime() > today.getTime();
    }

    return false;
  };
}
